import { createContext } from 'react';

import { type ILabelMappingCtx } from './types';

const defaultCtx: ILabelMappingCtx = {
  selectedLabel: undefined,
};

export const labelMappingCtx = createContext<ILabelMappingCtx>(defaultCtx);

labelMappingCtx.displayName = 'labelMappingCtx';
